/**
 * Brand config — single source of truth for multi-brand deployments.
 *
 * NEXT_PUBLIC_BRAND is set in the Vercel project env vars and baked into
 * the build by Next.js. Changing it requires a redeploy — it is NOT
 * a runtime variable.
 *
 * Values:
 *   (unset / "bluekeys")   → BlueKeys production site (bluekeys.co)
 *   "boutique-stays"       → Boutique Stays B2B site (boutiquestayshospitality.com)
 */

const BRAND = process.env.NEXT_PUBLIC_BRAND ?? "bluekeys";

export const brand =
  BRAND === "boutique-stays"
    ? {
        id: "boutique-stays" as const,
        name: "Boutique Stays",
        tagline: "Premium accommodation for your team",
        domain: "https://boutiquestayshospitality.com",
        /** null = bilingual (en+ar). 'en' = English-only. */
        singleLocale: "en" as const,
        colors: { primary: "#1a2744", accent: "#c9a84c" },
        /** WhatsApp number for CTAs — update before go-live */
        whatsapp: process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? "+201000000000",
        copyright: "© 2026 Boutique Stays.",
      }
    : {
        id: "bluekeys" as const,
        name: "BlueKeys",
        tagline: "Verified stays across Egypt",
        domain:
          process.env.NEXT_PUBLIC_SITE_URL ?? "https://www.bluekeys.co",
        singleLocale: null,
        colors: { primary: "#0e1e4d", accent: "#ffb020" },
        whatsapp: process.env.NEXT_PUBLIC_WHATSAPP_NUMBER ?? "+201000000000",
        copyright: "© 2026 BlueKeys. Built in Cairo.",
      };

export type Brand = typeof brand;
